<template>
    <div ref="customFieldSummary" v-if="hasCustomFieldSummaryAttributes">
        <!-- New Design -->
        <div class="custom-field-summary summary-container">
<!--            <div class="row">-->
<!--                <span class="col-lg-10 summary-title" >Custom fields</span>-->
<!--                <i @click="toggleCollapse" class="float-right cursor-pointer m-r-lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path d="M17 14L12 9L7 14L17 14Z" fill="#2E4051"/>-->
<!--                </svg>-->
<!--                </i>-->
<!--            </div>-->


            <div class="row m-0-8 marker-cursor " v-if="hasValue(attribute) && isNormal(attribute) && !isMandatory(attribute) && service.for_products !== 1" v-for="(attribute,index) of service.attributes" :key="index">
        <custom-field-summary-attribute :attribute="attribute" :service="service" :currency="currency" :unit="unit" :key="attribute.attribute_id"></custom-field-summary-attribute>
            </div>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import moment from "moment";
import {isNormal, isReserved, normalizeSelected, isHidden,isDeleted,isAvailable,isMandatory,priceText,hasValue,uuidv4} from "@/events/sharedMethods.js";
import BookingViewContractorTrackingMap from "@/modules/Booking/components/maps/BookingViewContractorTrackingMap.vue";

export default {
    Qname: "customFieldSummary",
    components: {BookingViewContractorTrackingMap},
    props: ['service', 'hasDate','unit','currency'],
    data() {
        return {
            businessType: this.service.businessType ?? null
        }
    },
    computed: {
        visits() {
            return this.service.visits
        },
        get_item_type() {
            return this.service.itemType
        },
        isVirtual() {
            return this.businessType == 'virtual'
        },
        hasCustomFieldSummaryAttributes() {
           if ( this?.service?.attributes){
            return this.service.attributes.some(attribute =>
                this.hasValue(attribute) &&
                this.isNormal(attribute) &&
                !this.isMandatory(attribute) &&
                this.service.for_products !== 1
            );
          }else {
            return null
          }

        }
    },
    methods: {
        isNormal,isHidden,isReserved,isDeleted,isAvailable,isMandatory,priceText,hasValue,normalizeSelected,uuidv4,
        toggleCollapse(index) {
            // this.visits[index].isCollapsed = !this.visits[index].isCollapsed
            $(this.$refs['toggleIcon' + index]).toggleClass('rotate-180')
            this.$forceUpdate()
        },

    },
    mounted() {
        EventBus.$on('onBusinessTypeChanged', business_type => {
            this.businessType = business_type
        });
        EventBus.$on('onTodayProcessLoaded', (todayProcessName, todayProcessClass, visit_id) => {
            // let visit = this.visits.filter(visit => visit.multiple_day_id==visit_id)[0]
            // visit.fieldworkerVisitStatus.title_confirmation = todayProcessName
            // visit.fieldworkerVisitStatus.divClass = todayProcessClass
            this.$forceUpdate();
        });
        let businessType = $('#business_address').val();
        if (businessType !== 'mobile' && businessType !== 'virtual') {
            businessType = 'fixed';
        }
        this.businessType = businessType
    }

}
</script>

<style scoped>
.fs-13 {
    font-size: 13px;
}



.custom-field-summary {
    Padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 12px;
    background-color: rgba(224, 226, 229, 0.5);
}

.m-0-8 {
    margin: 0 0 8px 0;
}

.summary-title{
    font-size: 16px;
    font-weight: 600;
}

.date-box {
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    padding: 2px 16px;
    background-color: #008CFA26;
    font-size: 17px;
    display: inline-block;
    text-align: center;
}

.col-p-top-10 {
    padding-top: 10px;
}

.font-size-17 {
    font-size: 17px;
}

.font-size-14 {
    font-size: 14px;
}

.status-label {
    color: #FFFFFF !important;
    border-radius: 100px !important;
    padding: 2px 8px 4px 8px !important;
    background-color: blue;
}

.labels-font {
    font-size: 13px;
    color: #2E4051;
}

.confirm-color {
    background-color: #37BD5D !important;
    color: #FFFFFF !important;
    border-radius: 100px !important;
    padding: 2px 8px 6px 8px !important;
    width: auto !important;
}

.color-text {
    color: #FFFFFF;
}

.unconfirm-color {
    background-color: #FF932F !important;
    color: #FFFFFF !important;
    border-radius: 100px !important;
    padding: 2px 8px 6px 8px !important;
    width: auto !important;

}

.status-div {
    color: #FFFFFF !important;
    border-radius: 100px !important;
    padding: 2px 12px 6px 12px !important;
    width: auto !important;
}

.float-position {
    float: right;
}

.p-left-0-15 {
    padding-left: 0px;
}

.collapsed {
    display: none;
}

.rotate {
    -moz-transition: all 0.5s linear;
    -webkit-transition: all 0.5s linear;
    transition: all 0.5s linear;
    padding-right: 5px;
}

.rotate-180 {
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
    display: inline-block;
}
.contractor-field{
    padding-bottom: 15px;
    padding-top: 15px;
}
@media (max-width: 768px) {
    .mobile-p-left-52 {
        padding-left: 52px !important;
    }

    .col-p-top-10 {
        padding-top: 0px !important;
    }

    .mobile-p-right-0 {
        padding-right: 0px !important;
    }
    .contractor-field{
        text-align: center;
        padding-bottom: 0px;
    }
}

@media (min-width: 1025px) and (max-width: 1440px) {
    .p-left-0-15 {
        padding-left: 15px;
    }
}
</style>